// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.pd-page {
  padding: 0 24px;
  max-width: 1280px;
  margin-inline: auto;
  min-height: 60vh;
}
@media (max-width: 767px) {
  .pd-page {
    padding: 0 16px;
  }
}
@media screen and (min-width: 768px) {
  .pd-page {
    padding: 0 24px;
  }
}

.pd-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  font-family: "Museo-300";
  font-size: 13px;
  color: #999;
}
.pd-breadcrumb__home {
  color: #767676;
  font-size: 14px;
  transition: color 0.2s;
}
.pd-breadcrumb__home:hover {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.pd-breadcrumb__sep {
  color: #ccc;
  -webkit-user-select: none;
          user-select: none;
}
.pd-breadcrumb__link {
  color: #767676;
  transition: color 0.2s;
}
.pd-breadcrumb__link:hover {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.pd-breadcrumb__current {
  color: #676a6c;
  font-family: "Museo-regular";
}

.pd-layout {
  display: flex;
  gap: 40px;
  padding: 24px 0 60px;
}
@media (max-width: 767px) {
  .pd-layout {
    flex-direction: column;
    gap: 24px;
    padding: 16px 0 40px;
  }
}
.pd-layout__image {
  flex: 0 0 40%;
  max-width: 40%;
}
@media (max-width: 767px) {
  .pd-layout__image {
    flex: none;
    max-width: 100%;
  }
}
.pd-layout__details {
  flex: 1;
  min-width: 0;
}

.pd-image {
  background: #fff;
  border: 1px solid #f1f1f2;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pd-image img {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: contain;
  display: block;
}

.pd-title {
  font-size: 28px;
  font-weight: 700;
  font-family: "Museo-700";
  color: #676a6c;
  line-height: 1.25;
  margin: 0 0 12px;
}
@media (max-width: 480px) {
  .pd-title {
    font-size: 24px;
  }
}

.pd-price {
  display: block;
  font-size: 24px;
  font-weight: 700;
  font-family: "Museo-700";
  color: rgb(105, 190, 40);
  margin-bottom: 20px;
}

.pd-description {
  font-family: "Museo-300";
  font-size: 15px;
  color: #676a6c;
  line-height: 1.75;
  margin-bottom: 28px;
  max-width: 640px;
}
.pd-description ::ng-deep p {
  margin: 0 0 16px;
}
.pd-description ::ng-deep p:last-child {
  margin-bottom: 0;
}
.pd-description ::ng-deep h1, .pd-description ::ng-deep h2, .pd-description ::ng-deep h3, .pd-description ::ng-deep h4, .pd-description ::ng-deep h5, .pd-description ::ng-deep h6 {
  font-family: "Museo-700";
  color: #676a6c;
  margin: 28px 0 10px;
  line-height: 1.3;
}
.pd-description ::ng-deep h1:first-child, .pd-description ::ng-deep h2:first-child, .pd-description ::ng-deep h3:first-child, .pd-description ::ng-deep h4:first-child, .pd-description ::ng-deep h5:first-child, .pd-description ::ng-deep h6:first-child {
  margin-top: 0;
}
.pd-description ::ng-deep h2 {
  font-size: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e7eaec;
}
.pd-description ::ng-deep h3 {
  font-size: 17px;
}
.pd-description ::ng-deep h4 {
  font-size: 15px;
}
.pd-description ::ng-deep blockquote {
  margin: 16px 0;
  padding: 12px 16px;
  border-left: 3px solid rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
  font-style: italic;
  color: #808486;
}
.pd-description ::ng-deep blockquote p {
  margin-bottom: 0;
}
.pd-description ::ng-deep ul, .pd-description ::ng-deep ol {
  padding-left: 24px;
  margin: 0 0 16px;
}
.pd-description ::ng-deep ul {
  list-style: disc;
}
.pd-description ::ng-deep ul ul {
  list-style: circle;
  margin-bottom: 0;
}
.pd-description ::ng-deep ol {
  list-style: decimal;
}
.pd-description ::ng-deep li {
  margin-bottom: 6px;
  line-height: 1.6;
  padding-left: 4px;
}
.pd-description ::ng-deep li:last-child {
  margin-bottom: 0;
}
.pd-description ::ng-deep table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 13px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e7eaec;
}
.pd-description ::ng-deep table th, .pd-description ::ng-deep table td {
  padding: 10px 14px;
  text-align: left;
  border-bottom: 1px solid #e7eaec;
}
.pd-description ::ng-deep table th {
  background: #f1f1f2;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
}
.pd-description ::ng-deep table tr:last-child td {
  border-bottom: none;
}
.pd-description ::ng-deep table tr:hover td {
  background: rgba(0, 173, 208, 0.02);
}
.pd-description ::ng-deep strong, .pd-description ::ng-deep b {
  font-weight: 700;
  color: #535657;
}
.pd-description ::ng-deep em, .pd-description ::ng-deep i {
  font-style: italic;
}
.pd-description ::ng-deep a {
  color: rgb(0, 173, 208);
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 173, 208, 0.3);
  transition: all 0.15s ease;
}
.pd-description ::ng-deep a:hover {
  color: #007a93;
  border-bottom-color: rgb(0, 173, 208);
}
.pd-description ::ng-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 12px 0;
}
.pd-description ::ng-deep br {
  display: block;
  content: "";
  margin: 6px 0;
}
.pd-description ::ng-deep hr {
  border: none;
  border-top: 1px solid #e7eaec;
  margin: 20px 0;
}

.pd-variant label, .pd-form-group label {
  display: block;
  font-family: "Museo-regular";
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #676a6c;
  margin-bottom: 4px;
}

::ng-deep .pd-meta-block {
  margin: 20px 0 24px;
  padding: 16px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border-left: 3px solid rgb(105, 190, 40);
}
::ng-deep .pd-meta-block .pd-meta-line {
  font-family: "Museo-300";
  font-size: 14px;
  color: #676a6c;
  margin: 0 0 8px;
  line-height: 1.6;
  display: flex;
  gap: 4px;
}
::ng-deep .pd-meta-block .pd-meta-line:last-child {
  margin-bottom: 0;
}
::ng-deep .pd-meta-block .pd-meta-line strong {
  color: #4e5052;
  font-weight: 700;
  white-space: nowrap;
}

.pd-variant select, .pd-form-group select {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  height: 38px;
  background-color: #fff;
  color: #444;
  font-family: "Museo-300";
  font-size: 13px;
  appearance: auto;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pd-variant select:focus, .pd-form-group select:focus {
  outline: none;
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.12);
}
.pd-variant select:disabled, .pd-form-group select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.pd-assessment-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.pd-variant {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}
.pd-variant select {
  max-width: 300px;
}

.pd-custom-field {
  margin-bottom: 16px;
  max-width: 400px;
}
.pd-custom-field label {
  display: block;
  font-family: "Museo-300";
  font-size: 13px;
  color: #676a6c;
  margin-bottom: 6px;
  line-height: 1.5;
}
.pd-custom-field label b {
  font-weight: 700;
  font-size: 14px;
  color: #4e5052;
}
.pd-custom-field label br {
  display: none;
}
.pd-custom-field label br.visible {
  display: block;
}
.pd-custom-field label span {
  display: block;
  font-size: 12px;
  color: #ccc;
  margin-top: 2px;
}

.pd-input {
  width: 100%;
  max-width: 400px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 10px 14px;
  height: 42px;
  font-family: "Museo-300";
  font-size: 14px;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pd-input:focus {
  outline: none;
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.pd-input::placeholder {
  color: #ccc;
}

.pd-cart {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e7eaec;
}
.pd-cart__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pd-qty-label {
  margin-bottom: 8px;
}
.pd-qty-label p {
  font-family: "Museo-300";
  font-size: 13px;
  font-weight: 600;
  color: #676a6c;
  margin: 0;
}

.pd-qty-inline-label {
  font-family: "Museo-300";
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #ccc;
  margin: 0;
}

.pd-qty {
  width: 72px;
  height: 42px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 4px 8px;
  font-family: "Museo-300";
  font-size: 15px;
  text-align: center;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pd-qty::-webkit-inner-spin-button, .pd-qty::-webkit-outer-spin-button {
  opacity: 1;
  height: 28px;
}
.pd-qty:focus {
  outline: none;
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 3px rgba(105, 190, 40, 0.1);
}

.pd-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Museo-regular";
  font-size: 14px;
  font-weight: 600;
  padding: 11px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  line-height: 1;
  letter-spacing: 0.02em;
}
.pd-btn--cart {
  background-color: rgb(105, 190, 40);
  color: #fff;
  box-shadow: 0 2px 6px rgba(105, 190, 40, 0.25);
}
.pd-btn--cart:hover {
  background-color: #5ba523;
  box-shadow: 0 4px 12px rgba(105, 190, 40, 0.3);
  color: #fff;
  text-decoration: none;
}
.pd-btn--apply {
  background-color: rgb(0, 173, 208);
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 173, 208, 0.25);
}
.pd-btn--apply:hover {
  background-color: #008ba7;
  box-shadow: 0 4px 12px rgba(0, 173, 208, 0.3);
  color: #fff;
  text-decoration: none;
}
.pd-btn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none;
}

.pd-bulk-msg {
  margin-top: 16px;
  font-family: "Museo-300";
  font-size: 13px;
  color: #999;
  line-height: 1.6;
}
.pd-bulk-msg a {
  color: rgb(0, 173, 208);
  text-decoration: underline;
}
.pd-bulk-msg a:hover {
  color: #00839d;
}

::ng-deep .certification-link {
  color: #676a6c !important;
  text-decoration: underline;
}

::ng-deep .toolset-learner-kit {
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
}
::ng-deep .toolset-learner-kit th {
  position: relative;
  border: 0 !important;
}
::ng-deep .toolset-learner-kit th code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep .toolset-learner-kit th:not(:first-child) {
  text-align: center;
}
::ng-deep .toolset-learner-kit th em {
  font-style: normal;
  position: absolute;
  right: -6px;
}
::ng-deep .toolset-learner-kit tr td:not(:first-child) {
  text-align: center;
}
::ng-deep .toolset-learner-kit tr td:not(:first-child) code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep .toolset-learner-kit tr:last-child td {
  background: #fff;
  border: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-product-details/public-product-details.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA+YF;AA7YE;EANF;IAOI,eAAA;EAgZF;AACF;AA9YE;EAVF;IAWI,eAAA;EAiZF;AACF;;AA7YA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,wBDrBS;ECsBT,eAAA;EACA,WAAA;AAgZF;AA9YE;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AAgZJ;AA9YI;EACE,uBDZU;ECaV,qBAAA;AAgZN;AA5YE;EACE,WAAA;EACA,yBAAA;UAAA,iBAAA;AA8YJ;AA3YE;EACE,cAAA;EACA,sBAAA;AA6YJ;AA3YI;EACE,uBD3BU;EC4BV,qBAAA;AA6YN;AAzYE;EACE,cDnBiB;ECoBjB,4BDnDO;AC8bX;;AAtYA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAyYF;AAvYE;EALF;IAMI,sBAAA;IACA,SAAA;IACA,oBAAA;EA0YF;AACF;AAxYE;EACE,aAAA;EACA,cAAA;AA0YJ;AAxYI;EAJF;IAKI,UAAA;IACA,eAAA;EA2YJ;AACF;AAxYE;EACE,OAAA;EACA,YAAA;AA0YJ;;AArYA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAwYF;AAtYE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAwYJ;;AAnYA;EACE,eAAA;EACA,gBAAA;EACA,wBDzGS;EC0GT,cD5EmB;EC6EnB,iBAAA;EACA,gBAAA;AAsYF;AApYE;EARF;IASI,eAAA;EAuYF;AACF;;AAnYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBDxHS;ECyHT,wBDvGc;ECwGd,mBAAA;AAsYF;;AAlYA;EACE,wBDlIS;ECmIT,eAAA;EACA,cDnGmB;ECoGnB,iBAAA;EACA,mBAAA;EACA,gBAAA;AAqYF;AAhYI;EACE,gBAAA;AAkYN;AAhYM;EAAe,gBAAA;AAmYrB;AA/XI;EACE,wBDjJK;ECkJL,cDpHe;ECqHf,mBAAA;EACA,gBAAA;AAiYN;AA/XM;EAAgB,aAAA;AAkYtB;AA/XI;EACE,eAAA;EACA,mBAAA;EACA,gCAAA;AAiYN;AA9XI;EACE,eAAA;AAgYN;AA7XI;EAAK,eAAA;AAgYT;AA7XI;EACE,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;AA+XN;AA7XM;EAAI,gBAAA;AAgYV;AA5XI;EACE,kBAAA;EACA,gBAAA;AA8XN;AA3XI;EACE,gBAAA;AA6XN;AA3XM;EAAK,kBAAA;EAAoB,gBAAA;AA+X/B;AA5XI;EACE,mBAAA;AA8XN;AA3XI;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AA6XN;AA3XM;EAAe,gBAAA;AA8XrB;AA1XI;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA4XN;AA1XM;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AA4XR;AAzXM;EACE,mBDpLc;ECqLd,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD5La;ACujBrB;AAxXM;EAAmB,mBAAA;AA2XzB;AAzXM;EAAc,mCAAA;AA4XpB;AAxXI;EACE,gBAAA;EACA,cAAA;AA0XN;AAvXI;EACE,kBAAA;AAyXN;AArXI;EACE,uBDnOU;ECoOV,qBAAA;EACA,gBAAA;EACA,+CAAA;EACA,0BAAA;AAuXN;AArXM;EACE,cAAA;EACA,qCD3OQ;ACkmBhB;AAlXI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAoXN;AAhXI;EACE,cAAA;EACA,WAAA;EACA,aAAA;AAkXN;AA9WI;EACE,YAAA;EACA,6BAAA;EACA,cAAA;AAgXN;;AAzWA;EACE,cAAA;EACA,4BD5RS;EC6RT,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cDjQmB;ECkQnB,kBAAA;AA4WF;;AAxWA;EACE,mBAAA;EACA,kBAAA;EACA,mBDjQoB;ECkQpB,kBAAA;EACA,wCAAA;AA2WF;AAzWE;EACE,wBD/SO;ECgTP,eAAA;EACA,cDhRiB;ECiRjB,eAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;AA2WJ;AAzWI;EAAe,gBAAA;AA4WnB;AA1WI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA4WN;;AAvWA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,wBDzUS;EC0UT,eAAA;EACA,gBAAA;EACA,8CAAA;AA0WF;AAxWE;EACE,aAAA;EACA,8BD7TY;EC8TZ,6CAAA;AA0WJ;AAvWE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;AAyWJ;;AApWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAuWF;;AAzVA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA4VF;AAtVE;EAEE,gBAAA;AAuVJ;;AAlVA;EACE,mBAAA;EACA,gBAAA;AAqVF;AAnVE;EACE,cAAA;EACA,wBDrYO;ECsYP,eAAA;EACA,cDtWiB;ECuWjB,kBAAA;EACA,gBAAA;AAqVJ;AAnVI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAqVN;AAlVI;EACE,aAAA;AAoVN;AAlVM;EACE,cAAA;AAoVR;AAhVI;EACE,cAAA;EACA,eAAA;EACA,WDpXc;ECqXd,eAAA;AAkVN;;AA7UA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBDzaS;EC0aT,eAAA;EACA,cD1YmB;EC2YnB,gBAAA;EACA,8CAAA;AAgVF;AA9UE;EACE,aAAA;EACA,8BD9ZY;EC+ZZ,4CAAA;AAgVJ;AA7UE;EACE,WD9YgB;AC6tBpB;;AA1UA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA6UF;AA3UE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA6UJ;;AAzUA;EACE,kBAAA;AA4UF;AA1UE;EACE,wBD5cO;EC6cP,eAAA;EACA,gBAAA;EACA,cD9aiB;EC+ajB,SAAA;AA4UJ;;AAxUA;EACE,wBDrdS;ECsdT,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WDlbkB;ECmblB,SAAA;AA2UF;;AAxUA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBDpeS;ECqeT,eAAA;EACA,kBAAA;EACA,cDtcmB;ECucnB,gBAAA;EACA,8CAAA;AA2UF;AAzUE;EAEE,UAAA;EACA,YAAA;AA0UJ;AAvUE;EACE,aAAA;EACA,+BD9dY;EC+dZ,6CAAA;AAyUJ;;AApUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BD3fS;EC4fT,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;AAuUF;AArUE;EACE,mCDrfY;ECsfZ,WAAA;EACA,8CAAA;AAuUJ;AArUI;EACE,yBAAA;EACA,8CAAA;EACA,WAAA;EACA,qBAAA;AAuUN;AAnUE;EACE,kCDpgBY;ECqgBZ,WAAA;EACA,6CAAA;AAqUJ;AAnUI;EACE,yBAAA;EACA,6CAAA;EACA,WAAA;EACA,qBAAA;AAqUN;AAjUE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAmUJ;;AA9TA;EACE,gBAAA;EACA,wBD9iBS;EC+iBT,eAAA;EACA,WAAA;EACA,gBAAA;AAiUF;AA/TE;EACE,uBDjiBY;ECkiBZ,0BAAA;AAiUJ;AA/TI;EACE,cAAA;AAiUN;;AA3TA;EACE,yBAAA;EACA,0BAAA;AA8TF;;AA3TA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA8TF;AA5TE;EACE,kBAAA;EACA,oBAAA;AA8TJ;AA5TI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AA8TN;AA3TI;EACE,kBAAA;AA6TN;AA1TI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AA4TN;AAxTE;EACE,kBAAA;AA0TJ;AAxTI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AA0TN;AAtTE;EACE,gBAAA;EACA,oBAAA;AAwTJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n// ── Page Container ──\n.pd-page {\n  padding: 0 24px;\n  max-width: 1280px;\n  margin-inline: auto;\n  min-height: 60vh;\n\n  @media (max-width: 767px) {\n    padding: 0 16px;\n  }\n\n  @media screen and (min-width: 768px) {\n    padding: 0 24px;\n  }\n}\n\n// ── Breadcrumb ──\n.pd-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 0;\n  font-family: $muso-300;\n  font-size: 13px;\n  color: #999;\n\n  &__home {\n    color: #767676;\n    font-size: 14px;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $clarify-color;\n      text-decoration: none;\n    }\n  }\n\n  &__sep {\n    color: #ccc;\n    user-select: none;\n  }\n\n  &__link {\n    color: #767676;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $clarify-color;\n      text-decoration: none;\n    }\n  }\n\n  &__current {\n    color: $body-content-color;\n    font-family: $muso-500;\n  }\n}\n\n// ── Two-Column Layout ──\n.pd-layout {\n  display: flex;\n  gap: 40px;\n  padding: 24px 0 60px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: 24px;\n    padding: 16px 0 40px;\n  }\n\n  &__image {\n    flex: 0 0 40%;\n    max-width: 40%;\n\n    @media (max-width: 767px) {\n      flex: none;\n      max-width: 100%;\n    }\n  }\n\n  &__details {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n// ── Product Image ──\n.pd-image {\n  background: #fff;\n  border: 1px solid $color-neutral-light;\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    height: auto;\n    max-height: 500px;\n    object-fit: contain;\n    display: block;\n  }\n}\n\n// ── Product Title ──\n.pd-title {\n  font-size: 28px;\n  font-weight: 700;\n  font-family: $muso-700;\n  color: $body-content-color;\n  line-height: 1.25;\n  margin: 0 0 12px;\n\n  @media (max-width: 480px) {\n    font-size: 24px;\n  }\n}\n\n// ── Price ──\n.pd-price {\n  display: block;\n  font-size: 24px;\n  font-weight: 700;\n  font-family: $muso-700;\n  color: $develop-color;\n  margin-bottom: 20px;\n}\n\n// ── Description ──\n.pd-description {\n  font-family: $muso-300;\n  font-size: 15px;\n  color: $body-content-color;\n  line-height: 1.75;\n  margin-bottom: 28px;\n  max-width: 640px;\n\n  ::ng-deep {\n\n    // Paragraphs\n    p {\n      margin: 0 0 16px;\n\n      &:last-child { margin-bottom: 0; }\n    }\n\n    // Headings inside description\n    h1, h2, h3, h4, h5, h6 {\n      font-family: $muso-700;\n      color: $body-content-color;\n      margin: 28px 0 10px;\n      line-height: 1.3;\n\n      &:first-child { margin-top: 0; }\n    }\n\n    h2 {\n      font-size: 20px;\n      padding-bottom: 8px;\n      border-bottom: 1px solid $color-grey-1;\n    }\n\n    h3 {\n      font-size: 17px;\n    }\n\n    h4 { font-size: 15px; }\n\n    // Blockquotes (sometimes used for section descriptions)\n    blockquote {\n      margin: 16px 0;\n      padding: 12px 16px;\n      border-left: 3px solid $develop-color;\n      background: rgba($develop-color, 0.03);\n      font-style: italic;\n      color: lighten($body-content-color, 10%);\n\n      p { margin-bottom: 0; }\n    }\n\n    // Lists\n    ul, ol {\n      padding-left: 24px;\n      margin: 0 0 16px;\n    }\n\n    ul {\n      list-style: disc;\n\n      ul { list-style: circle; margin-bottom: 0; }\n    }\n\n    ol {\n      list-style: decimal;\n    }\n\n    li {\n      margin-bottom: 6px;\n      line-height: 1.6;\n      padding-left: 4px;\n\n      &:last-child { margin-bottom: 0; }\n    }\n\n    // Tables\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin: 20px 0;\n      font-size: 13px;\n      border-radius: 6px;\n      overflow: hidden;\n      border: 1px solid $color-grey-1;\n\n      th, td {\n        padding: 10px 14px;\n        text-align: left;\n        border-bottom: 1px solid $color-grey-1;\n      }\n\n      th {\n        background: $color-neutral-light;\n        font-weight: 700;\n        font-size: 11px;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n      }\n\n      tr:last-child td { border-bottom: none; }\n\n      tr:hover td { background: rgba($clarify-color, 0.02); }\n    }\n\n    // Inline formatting\n    strong, b {\n      font-weight: 700;\n      color: darken($body-content-color, 8%);\n    }\n\n    em, i {\n      font-style: italic;\n    }\n\n    // Links\n    a {\n      color: $clarify-color;\n      text-decoration: none;\n      font-weight: 500;\n      border-bottom: 1px solid rgba($clarify-color, 0.3);\n      transition: all 0.15s ease;\n\n      &:hover {\n        color: darken($clarify-color, 12%);\n        border-bottom-color: $clarify-color;\n      }\n    }\n\n    // Images inside description\n    img {\n      max-width: 100%;\n      height: auto;\n      border-radius: 6px;\n      margin: 12px 0;\n    }\n\n    // Line breaks — show them but with controlled spacing\n    br {\n      display: block;\n      content: '';\n      margin: 6px 0;\n    }\n\n    // Horizontal rules\n    hr {\n      border: none;\n      border-top: 1px solid $color-grey-1;\n      margin: 20px 0;\n    }\n  }\n}\n\n\n// ── Shared Form Styles ──\n%pd-label {\n  display: block;\n  font-family: $muso-500;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: $body-content-color;\n  margin-bottom: 4px;\n}\n\n// ── Meta Info Block (Location, Time, Dates) ──\n::ng-deep .pd-meta-block {\n  margin: 20px 0 24px;\n  padding: 16px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border-left: 3px solid $develop-color;\n\n  .pd-meta-line {\n    font-family: $muso-300;\n    font-size: 14px;\n    color: $body-content-color;\n    margin: 0 0 8px;\n    line-height: 1.6;\n    display: flex;\n    gap: 4px;\n\n    &:last-child { margin-bottom: 0; }\n\n    strong {\n      color: darken($body-content-color, 10%);\n      font-weight: 700;\n      white-space: nowrap;\n    }\n  }\n}\n\n%pd-select {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  height: 38px;\n  background-color: #fff;\n  color: #444;\n  font-family: $muso-300;\n  font-size: 13px;\n  appearance: auto;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    outline: none;\n    border-color: $clarify-color;\n    box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.12);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n  }\n}\n\n// ── Assessment Form ──\n.pd-assessment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.pd-form-group {\n  label {\n    @extend %pd-label;\n  }\n\n  select {\n    @extend %pd-select;\n  }\n}\n\n// ── Variant Selector ──\n.pd-variant {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n\n  label {\n    @extend %pd-label;\n  }\n\n  select {\n    @extend %pd-select;\n    max-width: 300px;\n  }\n}\n\n// ── Custom Fields ──\n.pd-custom-field {\n  margin-bottom: 16px;\n  max-width: 400px;\n\n  label {\n    display: block;\n    font-family: $muso-300;\n    font-size: 13px;\n    color: $body-content-color;\n    margin-bottom: 6px;\n    line-height: 1.5;\n\n    b {\n      font-weight: 700;\n      font-size: 14px;\n      color: darken($body-content-color, 10%);\n    }\n\n    br {\n      display: none;\n\n      &.visible {\n        display: block;\n      }\n    }\n\n    span {\n      display: block;\n      font-size: 12px;\n      color: $color-neutral-mid;\n      margin-top: 2px;\n    }\n  }\n}\n\n.pd-input {\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 10px 14px;\n  height: 42px;\n  font-family: $muso-300;\n  font-size: 14px;\n  color: $body-content-color;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    outline: none;\n    border-color: $clarify-color;\n    box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n  }\n\n  &::placeholder {\n    color: $color-neutral-mid;\n  }\n}\n\n// ── Cart Section ──\n.pd-cart {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid $color-grey-1;\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n\n.pd-qty-label {\n  margin-bottom: 8px;\n\n  p {\n    font-family: $muso-300;\n    font-size: 13px;\n    font-weight: 600;\n    color: $body-content-color;\n    margin: 0;\n  }\n}\n\n.pd-qty-inline-label {\n  font-family: $muso-300;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: $color-neutral-mid;\n  margin: 0;\n}\n\n.pd-qty {\n  width: 72px;\n  height: 42px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-family: $muso-300;\n  font-size: 15px;\n  text-align: center;\n  color: $body-content-color;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    opacity: 1;\n    height: 28px;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: $develop-color;\n    box-shadow: 0 0 0 3px rgba($develop-color, 0.1);\n  }\n}\n\n// ── Buttons ──\n.pd-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: $muso-500;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 11px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  line-height: 1;\n  letter-spacing: 0.02em;\n\n  &--cart {\n    background-color: $develop-color;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba($develop-color, 0.25);\n\n    &:hover {\n      background-color: darken($develop-color, 6%);\n      box-shadow: 0 4px 12px rgba($develop-color, 0.3);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--apply {\n    background-color: $clarify-color;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba($clarify-color, 0.25);\n\n    &:hover {\n      background-color: darken($clarify-color, 8%);\n      box-shadow: 0 4px 12px rgba($clarify-color, 0.3);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    pointer-events: none;\n    box-shadow: none;\n  }\n}\n\n// ── Bulk Order Message ──\n.pd-bulk-msg {\n  margin-top: 16px;\n  font-family: $muso-300;\n  font-size: 13px;\n  color: #999;\n  line-height: 1.6;\n\n  a {\n    color: $clarify-color;\n    text-decoration: underline;\n\n    &:hover {\n      color: darken(#00add0, 10%);\n    }\n  }\n}\n\n// ── Legacy deep selectors for innerHTML content ──\n::ng-deep .certification-link {\n  color: $body-content-color !important;\n  text-decoration: underline;\n}\n\n::ng-deep .toolset-learner-kit {\n  border-bottom: 0;\n  border-left: 0;\n  border-right: 0;\n\n  th {\n    position: relative;\n    border: 0 !important;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: $body-content-color !important;\n      font-size: 1em !important;\n    }\n\n    &:not(:first-child) {\n      text-align: center;\n    }\n\n    em {\n      font-style: normal;\n      position: absolute;\n      right: -6px;\n    }\n  }\n\n  tr td:not(:first-child) {\n    text-align: center;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: $body-content-color !important;\n      font-size: 1em !important;\n    }\n  }\n\n  tr:last-child td {\n    background: #fff;\n    border: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
